import { Award, TrendingUp } from "@/lib/icons";

/**
 * Formatea un número para mostrar separadores de miles
 */
export const formatNumber = (value) => {
  if (!value && value !== 0) return "0";
  return Number(value).toLocaleString("es-MX");
};

/**
 * Formatea un porcentaje con 1 decimal
 */
export const formatPercentage = (value) => {
  if (!Number.isFinite(value)) return "0%";
  return `${value.toFixed(1)}%`;
};

/**
 * Formatea una fecha
 */
export const formatDate = (value) => {
  if (!value) return "Sin registro";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Sin registro";
  return date.toLocaleDateString("es-MX", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

/**
 * Elimina acentos y diacríticos para normalizar cadenas
 */
export const stripAccents = (value) => {
  if (!value) return "";
  try {
    return String(value)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  } catch {
    return String(value);
  }
};

/**
 * Asegura un porcentaje entre 0 y 100
 */
export const clampPercent = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.min(100, n));
};

// Simple helper para concatenar clases (suficiente para componentes que importan `cn`)
export function cn(...inputs) {
  return inputs
    .flat()
    .filter(Boolean)
    .map((i) => String(i).trim())
    .join(" ");
}

// Helper: badge de conversión (exportable para usar en tablas)
export function conversionBadge(value) {
  const n = Number(value || 0);
  const label = `${Number.isFinite(n) ? n.toFixed(1) : 0}%`;
  if (n >= 30)
    return {
      label,
      className:
        "bg-gradient-to-r from-emerald-500/20 to-emerald-500/10 text-emerald-700 ring-1 ring-emerald-500/30 font-semibold",
      icon: Award,
    };
  if (n >= 20)
    return {
      label,
      className:
        "bg-gradient-to-r from-amber-500/20 to-amber-500/10 text-amber-700 ring-1 ring-amber-500/30 font-semibold",
      icon: TrendingUp,
    };
  return {
    label,
    className:
      "bg-gradient-to-r from-slate-500/20 to-slate-500/10 text-slate-700 ring-1 ring-slate-500/30 font-semibold",
    icon: null,
  };
}
